var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.643.75H6.964l-.21-.438A.534.534 0 006.275 0H3.723a.528.528 0 00-.478.312L3.036.75H.357A.366.366 0 000 1.125v.75a.366.366 0 00.357.375h9.286A.366.366 0 0010 1.875v-.75A.366.366 0 009.643.75zm-8.455 10.2A1.1 1.1 0 002.257 12h5.486a1.1 1.1 0 001.069-1.055L9.286 3H.714l.474 7.95z"
  })));
}
export default SvgTrash;